import {
    AberdeenshireRecordType,
    AberdeenshireRecordSubType
} from "./AberdeenshireRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,    
    IMappingTextPack
} from "esdm-map";
import { ILayerGroup } from "esdm-map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: AberdeenshireRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monuments"
    });

    items.push({
        recordTypeCode: AberdeenshireRecordType.Event,
        recordSubTypeCode: null,
        heading: "Events"
    });

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designations"
    });

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: AberdeenshireRecordSubType.ListedBuilding,
        heading: "Listed Buildings"
    });

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: AberdeenshireRecordSubType.GardensAndDesignedLandscapes,
        heading: "Inventory Designed Landscapes"
    });

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: AberdeenshireRecordSubType.ScheduledMonument,
        heading: "Scheduled Monuments"
    });  

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: AberdeenshireRecordSubType.ConservationArea,
        heading: "Conservation Areas"
    });  

    items.push({
        recordTypeCode: AberdeenshireRecordType.Designation,
        recordSubTypeCode: AberdeenshireRecordSubType.Battlefields,
        heading: "Inventory Battlefields"
    });  
    
    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === AberdeenshireRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        if (layerGroup.layerType == AberdeenshireRecordType.Designation)
            return {
                id: featureProperties.FID,
                uid: featureProperties.ENTITY_REFERENCE,
                ref: featureProperties.DESIGNATION_REFERENCE,
                name: featureProperties.ENTITY_TITLE,
                recordType: layerGroup.layerType,
                recordSubType: layerGroup.layerSubType,
                recordSubTypeCode: layerGroup.layerSubType,
                data: featureProperties,
                heading: this.getHeading(layerGroup.layerType, layerGroup.layerSubType),
                layerGroup: layerGroup
            }
        else {
            return {
                id: featureProperties.id,
                uid: featureProperties.uid,
                ref: featureProperties.ref,
                name: featureProperties.name,
                recordType: featureProperties.rectype,
                recordSubType: featureProperties.recsubtype,
                recordSubTypeCode: featureProperties.recsubtypecode,
                data: featureProperties,
                heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
                layerGroup: layerGroup
            }
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        if (recordTypeInfoClick.recordType == "desig") {
            html = `<li>
                        <a class="external-link"href="[LINK]" target="_blank" title="Go to [DESIGNATION_REFERENCE] on HES website">
                            <span><i class="far fa-info-circle" aria-hidden="true"></i></span>
                            &nbsp;
                            <span>[DESIGNATION_REFERENCE]: [ENTITY_TITLE]</span>               
                        </a>
                    </li>`;
        } else {
            //add controller (or any arbitrary data) to the data object
            switch (recordTypeInfoClick.recordType.toLowerCase()) {
                case "mon":
                    recordTypeInfoClick.data.controller = "Monument";
                    break;
                case "event":
                    recordTypeInfoClick.data.controller = "Event";
                    break;
                case "desig":
                    recordTypeInfoClick.data.controller = "Designation";
                    break;
            }

            html = `
                     <li>
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                        &nbsp;
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                            <span>[name]</span>               
                        </a>
                        <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;
        }

        return html;
    }

    
}